module.exports = __webpack_public_path__ + "static/media/Equine RationChecker_no tagline.098ed542.svg";